export default "__VITE_ASSET__Bqy_cGwE__"